import * as X from "react";
import Gr, { forwardRef as Kr, useContext as $t, useMemo as Pr, cloneElement as kt } from "react";
import { LoadingIcon as It } from "@illa-design/icon";
import { css as Q, keyframes as Dt } from "@emotion/react";
import { getColor as ur, applyBoxStyle as Mt, deleteCssProps as Ft } from "@illa-design/theme";
var nr = { exports: {} }, ye = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function jt() {
  if (Nr)
    return ye;
  Nr = 1;
  var e = Gr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, p, h) {
    var d, y = {}, P = null, k = null;
    h !== void 0 && (P = "" + h), p.key !== void 0 && (P = "" + p.key), p.ref !== void 0 && (k = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: P, ref: k, props: y, _owner: o.current };
  }
  return ye.Fragment = n, ye.jsx = f, ye.jsxs = f, ye;
}
var Ee = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Vt() {
  return Ar || (Ar = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Gr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), k = Symbol.for("react.offscreen"), A = Symbol.iterator, g = "@@iterator";
    function M(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = A && t[A] || t[g];
      return typeof s == "function" ? s : null;
    }
    var S = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          u[m - 1] = arguments[m];
        N("error", t, u);
      }
    }
    function N(t, s, u) {
      {
        var m = S.ReactDebugCurrentFrame, x = m.getStackAddendum();
        x !== "" && (s += "%s", u = u.concat([x]));
        var $ = u.map(function(_) {
          return String(_);
        });
        $.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, $);
      }
    }
    var I = !1, c = !1, V = !1, O = !1, qe = !1, Re;
    Re = Symbol.for("react.module.reference");
    function Be(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || qe || t === o || t === h || t === d || O || t === k || I || c || V || typeof t == "object" && t !== null && (t.$$typeof === P || t.$$typeof === y || t.$$typeof === f || t.$$typeof === l || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Re || t.getModuleId !== void 0));
    }
    function Ge(t, s, u) {
      var m = t.displayName;
      if (m)
        return m;
      var x = s.displayName || s.name || "";
      return x !== "" ? u + "(" + x + ")" : u;
    }
    function we(t) {
      return t.displayName || "Context";
    }
    function B(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return we(s) + ".Consumer";
          case f:
            var u = t;
            return we(u._context) + ".Provider";
          case p:
            return Ge(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : B(t.type) || "Memo";
          case P: {
            var x = t, $ = x._payload, _ = x._init;
            try {
              return B(_($));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, ee = 0, Ce, Te, fe, Oe, le, Pe, Ne;
    function Ae() {
    }
    Ae.__reactDisabledLog = !0;
    function Ke() {
      {
        if (ee === 0) {
          Ce = console.log, Te = console.info, fe = console.warn, Oe = console.error, le = console.group, Pe = console.groupCollapsed, Ne = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ae,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        ee++;
      }
    }
    function Je() {
      {
        if (ee--, ee === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, t, {
              value: Ce
            }),
            info: Z({}, t, {
              value: Te
            }),
            warn: Z({}, t, {
              value: fe
            }),
            error: Z({}, t, {
              value: Oe
            }),
            group: Z({}, t, {
              value: le
            }),
            groupCollapsed: Z({}, t, {
              value: Pe
            }),
            groupEnd: Z({}, t, {
              value: Ne
            })
          });
        }
        ee < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var de = S.ReactCurrentDispatcher, pe;
    function te(t, s, u) {
      {
        if (pe === void 0)
          try {
            throw Error();
          } catch (x) {
            var m = x.stack.trim().match(/\n( *(at )?)/);
            pe = m && m[1] || "";
          }
        return `
` + pe + t;
      }
    }
    var ve = !1, ne;
    {
      var Ze = typeof WeakMap == "function" ? WeakMap : Map;
      ne = new Ze();
    }
    function v(t, s) {
      if (!t || ve)
        return "";
      {
        var u = ne.get(t);
        if (u !== void 0)
          return u;
      }
      var m;
      ve = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var $;
      $ = de.current, de.current = null, Ke();
      try {
        if (s) {
          var _ = function() {
            throw Error();
          };
          if (Object.defineProperty(_.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(_, []);
            } catch (H) {
              m = H;
            }
            Reflect.construct(t, [], _);
          } else {
            try {
              _.call();
            } catch (H) {
              m = H;
            }
            t.call(_.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (H) {
            m = H;
          }
          t();
        }
      } catch (H) {
        if (H && m && typeof H.stack == "string") {
          for (var b = H.stack.split(`
`), W = m.stack.split(`
`), D = b.length - 1, F = W.length - 1; D >= 1 && F >= 0 && b[D] !== W[F]; )
            F--;
          for (; D >= 1 && F >= 0; D--, F--)
            if (b[D] !== W[F]) {
              if (D !== 1 || F !== 1)
                do
                  if (D--, F--, F < 0 || b[D] !== W[F]) {
                    var q = `
` + b[D].replace(" at new ", " at ");
                    return t.displayName && q.includes("<anonymous>") && (q = q.replace("<anonymous>", t.displayName)), typeof t == "function" && ne.set(t, q), q;
                  }
                while (D >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        ve = !1, de.current = $, Je(), Error.prepareStackTrace = x;
      }
      var ie = t ? t.displayName || t.name : "", Or = ie ? te(ie) : "";
      return typeof t == "function" && ne.set(t, Or), Or;
    }
    function he(t, s, u) {
      return v(t, !1);
    }
    function ae(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function re(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, ae(t));
      if (typeof t == "string")
        return te(t);
      switch (t) {
        case h:
          return te("Suspense");
        case d:
          return te("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return he(t.render);
          case y:
            return re(t.type, s, u);
          case P: {
            var m = t, x = m._payload, $ = m._init;
            try {
              return re($(x), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var $e = Object.prototype.hasOwnProperty, mr = {}, yr = S.ReactDebugCurrentFrame;
    function ke(t) {
      if (t) {
        var s = t._owner, u = re(t.type, t._source, s ? s.type : null);
        yr.setExtraStackFrame(u);
      } else
        yr.setExtraStackFrame(null);
    }
    function dt(t, s, u, m, x) {
      {
        var $ = Function.call.bind($e);
        for (var _ in t)
          if ($(t, _)) {
            var b = void 0;
            try {
              if (typeof t[_] != "function") {
                var W = Error((m || "React class") + ": " + u + " type `" + _ + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[_] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[_](s, _, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              b = D;
            }
            b && !(b instanceof Error) && (ke(x), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, _, typeof b), ke(null)), b instanceof Error && !(b.message in mr) && (mr[b.message] = !0, ke(x), E("Failed %s type: %s", u, b.message), ke(null));
          }
      }
    }
    var pt = Array.isArray;
    function He(t) {
      return pt(t);
    }
    function vt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function ht(t) {
      try {
        return Er(t), !1;
      } catch {
        return !0;
      }
    }
    function Er(t) {
      return "" + t;
    }
    function br(t) {
      if (ht(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", vt(t)), Er(t);
    }
    var me = S.ReactCurrentOwner, mt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, gr, _r, Xe;
    Xe = {};
    function yt(t) {
      if ($e.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Et(t) {
      if ($e.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function bt(t, s) {
      if (typeof t.ref == "string" && me.current && s && me.current.stateNode !== s) {
        var u = B(me.current.type);
        Xe[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(me.current.type), t.ref), Xe[u] = !0);
      }
    }
    function gt(t, s) {
      {
        var u = function() {
          gr || (gr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function _t(t, s) {
      {
        var u = function() {
          _r || (_r = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var St = function(t, s, u, m, x, $, _) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: _,
        // Record the component responsible for creating this element.
        _owner: $
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function xt(t, s, u, m, x) {
      {
        var $, _ = {}, b = null, W = null;
        u !== void 0 && (br(u), b = "" + u), Et(s) && (br(s.key), b = "" + s.key), yt(s) && (W = s.ref, bt(s, x));
        for ($ in s)
          $e.call(s, $) && !mt.hasOwnProperty($) && (_[$] = s[$]);
        if (t && t.defaultProps) {
          var D = t.defaultProps;
          for ($ in D)
            _[$] === void 0 && (_[$] = D[$]);
        }
        if (b || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && gt(_, F), W && _t(_, F);
        }
        return St(t, b, W, x, m, me.current, _);
      }
    }
    var Qe = S.ReactCurrentOwner, Sr = S.ReactDebugCurrentFrame;
    function oe(t) {
      if (t) {
        var s = t._owner, u = re(t.type, t._source, s ? s.type : null);
        Sr.setExtraStackFrame(u);
      } else
        Sr.setExtraStackFrame(null);
    }
    var er;
    er = !1;
    function rr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function xr() {
      {
        if (Qe.current) {
          var t = B(Qe.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Rt(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Rr = {};
    function wt(t) {
      {
        var s = xr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function wr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = wt(s);
        if (Rr[u])
          return;
        Rr[u] = !0;
        var m = "";
        t && t._owner && t._owner !== Qe.current && (m = " It was passed a child from " + B(t._owner.type) + "."), oe(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), oe(null);
      }
    }
    function Cr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (He(t))
          for (var u = 0; u < t.length; u++) {
            var m = t[u];
            rr(m) && wr(m, s);
          }
        else if (rr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var x = M(t);
          if (typeof x == "function" && x !== t.entries)
            for (var $ = x.call(t), _; !(_ = $.next()).done; )
              rr(_.value) && wr(_.value, s);
        }
      }
    }
    function Ct(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var m = B(s);
          dt(u, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !er) {
          er = !0;
          var x = B(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Tt(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var m = s[u];
          if (m !== "children" && m !== "key") {
            oe(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), oe(null);
            break;
          }
        }
        t.ref !== null && (oe(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), oe(null));
      }
    }
    function Tr(t, s, u, m, x, $) {
      {
        var _ = Be(t);
        if (!_) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = Rt(x);
          W ? b += W : b += xr();
          var D;
          t === null ? D = "null" : He(t) ? D = "array" : t !== void 0 && t.$$typeof === r ? (D = "<" + (B(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : D = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", D, b);
        }
        var F = xt(t, s, u, x, $);
        if (F == null)
          return F;
        if (_) {
          var q = s.children;
          if (q !== void 0)
            if (m)
              if (He(q)) {
                for (var ie = 0; ie < q.length; ie++)
                  Cr(q[ie], t);
                Object.freeze && Object.freeze(q);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Cr(q, t);
        }
        return t === a ? Tt(F) : Ct(F), F;
      }
    }
    function Ot(t, s, u) {
      return Tr(t, s, u, !0);
    }
    function Pt(t, s, u) {
      return Tr(t, s, u, !1);
    }
    var Nt = Pt, At = Ot;
    Ee.Fragment = a, Ee.jsx = Nt, Ee.jsxs = At;
  }()), Ee;
}
process.env.NODE_ENV === "production" ? nr.exports = jt() : nr.exports = Vt();
var je = nr.exports;
function Lt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Yt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Wt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Yt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = Lt(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", Ve = "-moz-", R = "-webkit-", fr = "comm", lr = "rule", dr = "decl", zt = "@import", Jr = "@keyframes", Ut = "@layer", qt = Math.abs, Ye = String.fromCharCode, Bt = Object.assign;
function Gt(e, r) {
  return L(e, 0) ^ 45 ? (((r << 2 ^ L(e, 0)) << 2 ^ L(e, 1)) << 2 ^ L(e, 2)) << 2 ^ L(e, 3) : 0;
}
function Zr(e) {
  return e.trim();
}
function Kt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function w(e, r, n) {
  return e.replace(r, n);
}
function ar(e, r) {
  return e.indexOf(r);
}
function L(e, r) {
  return e.charCodeAt(r) | 0;
}
function ge(e, r, n) {
  return e.slice(r, n);
}
function K(e) {
  return e.length;
}
function pr(e) {
  return e.length;
}
function Ie(e, r) {
  return r.push(e), e;
}
function Jt(e, r) {
  return e.map(r).join("");
}
var We = 1, ce = 1, Hr = 0, z = 0, j = 0, ue = "";
function ze(e, r, n, a, o, i, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: We, column: ce, length: f, return: "" };
}
function be(e, r) {
  return Bt(ze("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Zt() {
  return j;
}
function Ht() {
  return j = z > 0 ? L(ue, --z) : 0, ce--, j === 10 && (ce = 1, We--), j;
}
function U() {
  return j = z < Hr ? L(ue, z++) : 0, ce++, j === 10 && (ce = 1, We++), j;
}
function J() {
  return L(ue, z);
}
function De() {
  return z;
}
function xe(e, r) {
  return ge(ue, e, r);
}
function _e(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Xr(e) {
  return We = ce = 1, Hr = K(ue = e), z = 0, [];
}
function Qr(e) {
  return ue = "", e;
}
function Me(e) {
  return Zr(xe(z - 1, or(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Xt(e) {
  for (; (j = J()) && j < 33; )
    U();
  return _e(e) > 2 || _e(j) > 3 ? "" : " ";
}
function Qt(e, r) {
  for (; --r && U() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return xe(e, De() + (r < 6 && J() == 32 && U() == 32));
}
function or(e) {
  for (; U(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && or(j);
        break;
      case 40:
        e === 41 && or(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function en(e, r) {
  for (; U() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && J() === 47)
      break;
  return "/*" + xe(r, z - 1) + "*" + Ye(e === 47 ? e : U());
}
function rn(e) {
  for (; !_e(J()); )
    U();
  return xe(e, z);
}
function tn(e) {
  return Qr(Fe("", null, null, null, [""], e = Xr(e), 0, [0], e));
}
function Fe(e, r, n, a, o, i, f, l, p) {
  for (var h = 0, d = 0, y = f, P = 0, k = 0, A = 0, g = 1, M = 1, S = 1, E = 0, N = "", I = o, c = i, V = a, O = N; M; )
    switch (A = E, E = U()) {
      case 40:
        if (A != 108 && L(O, y - 1) == 58) {
          ar(O += w(Me(E), "&", "&\f"), "&\f") != -1 && (S = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        O += Me(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        O += Xt(A);
        break;
      case 92:
        O += Qt(De() - 1, 7);
        continue;
      case 47:
        switch (J()) {
          case 42:
          case 47:
            Ie(nn(en(U(), De()), r, n), p);
            break;
          default:
            O += "/";
        }
        break;
      case 123 * g:
        l[h++] = K(O) * S;
      case 125 * g:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            M = 0;
          case 59 + d:
            S == -1 && (O = w(O, /\f/g, "")), k > 0 && K(O) - y && Ie(k > 32 ? kr(O + ";", a, n, y - 1) : kr(w(O, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            O += ";";
          default:
            if (Ie(V = $r(O, r, n, h, d, o, l, N, I = [], c = [], y), i), E === 123)
              if (d === 0)
                Fe(O, r, V, V, I, i, y, l, c);
              else
                switch (P === 99 && L(O, 3) === 110 ? 100 : P) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Fe(e, V, V, a && Ie($r(e, V, V, 0, 0, o, l, N, o, I = [], y), c), o, c, y, l, a ? I : c);
                    break;
                  default:
                    Fe(O, V, V, V, [""], c, 0, l, c);
                }
        }
        h = d = k = 0, g = S = 1, N = O = "", y = f;
        break;
      case 58:
        y = 1 + K(O), k = A;
      default:
        if (g < 1) {
          if (E == 123)
            --g;
          else if (E == 125 && g++ == 0 && Ht() == 125)
            continue;
        }
        switch (O += Ye(E), E * g) {
          case 38:
            S = d > 0 ? 1 : (O += "\f", -1);
            break;
          case 44:
            l[h++] = (K(O) - 1) * S, S = 1;
            break;
          case 64:
            J() === 45 && (O += Me(U())), P = J(), d = y = K(N = O += rn(De())), E++;
            break;
          case 45:
            A === 45 && K(O) == 2 && (g = 0);
        }
    }
  return i;
}
function $r(e, r, n, a, o, i, f, l, p, h, d) {
  for (var y = o - 1, P = o === 0 ? i : [""], k = pr(P), A = 0, g = 0, M = 0; A < a; ++A)
    for (var S = 0, E = ge(e, y + 1, y = qt(g = f[A])), N = e; S < k; ++S)
      (N = Zr(g > 0 ? P[S] + " " + E : w(E, /&\f/g, P[S]))) && (p[M++] = N);
  return ze(e, r, n, o === 0 ? lr : l, p, h, d);
}
function nn(e, r, n) {
  return ze(e, r, n, fr, Ye(Zt()), ge(e, 2, -2), 0);
}
function kr(e, r, n, a) {
  return ze(e, r, n, dr, ge(e, 0, a), ge(e, a + 1, -1), a);
}
function se(e, r) {
  for (var n = "", a = pr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function an(e, r, n, a) {
  switch (e.type) {
    case Ut:
      if (e.children.length)
        break;
    case zt:
    case dr:
      return e.return = e.return || e.value;
    case fr:
      return "";
    case Jr:
      return e.return = e.value + "{" + se(e.children, a) + "}";
    case lr:
      e.value = e.props.join(",");
  }
  return K(n = se(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function on(e) {
  var r = pr(e);
  return function(n, a, o, i) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](n, a, o, i) || "";
    return f;
  };
}
function sn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function cn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var un = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = J(), o === 38 && i === 12 && (n[a] = 1), !_e(i); )
    U();
  return xe(r, z);
}, fn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (_e(o)) {
      case 0:
        o === 38 && J() === 12 && (n[a] = 1), r[a] += un(z - 1, n, a);
        break;
      case 2:
        r[a] += Me(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = J() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ye(o);
    }
  while (o = U());
  return r;
}, ln = function(r, n) {
  return Qr(fn(Xr(r), n));
}, Ir = /* @__PURE__ */ new WeakMap(), dn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Ir.get(a)) && !o) {
      Ir.set(r, !0);
      for (var i = [], f = ln(n, i), l = a.props, p = 0, h = 0; p < f.length; p++)
        for (var d = 0; d < l.length; d++, h++)
          r.props[h] = i[p] ? f[p].replace(/&\f/g, l[d]) : l[d] + " " + f[p];
    }
  }
}, pn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, vn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", hn = function(r) {
  return r.type === "comm" && r.children.indexOf(vn) > -1;
}, mn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!n.parent, l = f ? n.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var h = l[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (hn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, et = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, yn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!et(n[a]))
      return !0;
  return !1;
}, Dr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, En = function(r, n, a) {
  et(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Dr(r)) : yn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Dr(r)));
};
function rt(e, r) {
  switch (Gt(e, r)) {
    case 5103:
      return R + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return R + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return R + e + Ve + e + Y + e + e;
    case 6828:
    case 4268:
      return R + e + Y + e + e;
    case 6165:
      return R + e + Y + "flex-" + e + e;
    case 5187:
      return R + e + w(e, /(\w+).+(:[^]+)/, R + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return R + e + Y + "flex-item-" + w(e, /flex-|-self/, "") + e;
    case 4675:
      return R + e + Y + "flex-line-pack" + w(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return R + e + Y + w(e, "shrink", "negative") + e;
    case 5292:
      return R + e + Y + w(e, "basis", "preferred-size") + e;
    case 6060:
      return R + "box-" + w(e, "-grow", "") + R + e + Y + w(e, "grow", "positive") + e;
    case 4554:
      return R + w(e, /([^-])(transform)/g, "$1" + R + "$2") + e;
    case 6187:
      return w(w(w(e, /(zoom-|grab)/, R + "$1"), /(image-set)/, R + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return w(e, /(image-set\([^]*)/, R + "$1$`$1");
    case 4968:
      return w(w(e, /(.+:)(flex-)?(.*)/, R + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + R + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return w(e, /(.+)-inline(.+)/, R + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (K(e) - 1 - r > 6)
        switch (L(e, r + 1)) {
          case 109:
            if (L(e, r + 4) !== 45)
              break;
          case 102:
            return w(e, /(.+:)(.+)-([^]+)/, "$1" + R + "$2-$3$1" + Ve + (L(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~ar(e, "stretch") ? rt(w(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (L(e, r + 1) !== 115)
        break;
    case 6444:
      switch (L(e, K(e) - 3 - (~ar(e, "!important") && 10))) {
        case 107:
          return w(e, ":", ":" + R) + e;
        case 101:
          return w(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + R + (L(e, 14) === 45 ? "inline-" : "") + "box$3$1" + R + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (L(e, r + 11)) {
        case 114:
          return R + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return R + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return R + e + Y + w(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return R + e + Y + e + e;
  }
  return e;
}
var bn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case dr:
        r.return = rt(r.value, r.length);
        break;
      case Jr:
        return se([be(r, {
          value: w(r.value, "@", "@" + R)
        })], o);
      case lr:
        if (r.length)
          return Jt(r.props, function(i) {
            switch (Kt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return se([be(r, {
                  props: [w(i, /:(read-\w+)/, ":" + Ve + "$1")]
                })], o);
              case "::placeholder":
                return se([be(r, {
                  props: [w(i, /:(plac\w+)/, ":" + R + "input-$1")]
                }), be(r, {
                  props: [w(i, /:(plac\w+)/, ":" + Ve + "$1")]
                }), be(r, {
                  props: [w(i, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, gn = [bn], _n = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var M = g.getAttribute("data-emotion");
      M.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || gn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var M = g.getAttribute("data-emotion").split(" "), S = 1; S < M.length; S++)
        i[M[S]] = !0;
      l.push(g);
    }
  );
  var p, h = [dn, pn];
  process.env.NODE_ENV !== "production" && h.push(mn({
    get compat() {
      return A.compat;
    }
  }), En);
  {
    var d, y = [an, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== fr && d.insert(g.value + "{}"));
    } : sn(function(g) {
      d.insert(g);
    })], P = on(h.concat(o, y)), k = function(M) {
      return se(tn(M), P);
    };
    p = function(M, S, E, N) {
      d = E, process.env.NODE_ENV !== "production" && S.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + S.map);
        }
      }), k(M ? M + "{" + S.styles + "}" : S.styles), N && (A.inserted[S.name] = !0);
    };
  }
  var A = {
    key: n,
    sheet: new Wt({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return A.sheet.hydrate(l), A;
}, ir = { exports: {} }, C = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mr;
function Sn() {
  if (Mr)
    return C;
  Mr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function N(c) {
    if (typeof c == "object" && c !== null) {
      var V = c.$$typeof;
      switch (V) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case A:
                case k:
                case f:
                  return c;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function I(c) {
    return N(c) === h;
  }
  return C.AsyncMode = p, C.ConcurrentMode = h, C.ContextConsumer = l, C.ContextProvider = f, C.Element = r, C.ForwardRef = d, C.Fragment = a, C.Lazy = A, C.Memo = k, C.Portal = n, C.Profiler = i, C.StrictMode = o, C.Suspense = y, C.isAsyncMode = function(c) {
    return I(c) || N(c) === p;
  }, C.isConcurrentMode = I, C.isContextConsumer = function(c) {
    return N(c) === l;
  }, C.isContextProvider = function(c) {
    return N(c) === f;
  }, C.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, C.isForwardRef = function(c) {
    return N(c) === d;
  }, C.isFragment = function(c) {
    return N(c) === a;
  }, C.isLazy = function(c) {
    return N(c) === A;
  }, C.isMemo = function(c) {
    return N(c) === k;
  }, C.isPortal = function(c) {
    return N(c) === n;
  }, C.isProfiler = function(c) {
    return N(c) === i;
  }, C.isStrictMode = function(c) {
    return N(c) === o;
  }, C.isSuspense = function(c) {
    return N(c) === y;
  }, C.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === y || c === P || typeof c == "object" && c !== null && (c.$$typeof === A || c.$$typeof === k || c.$$typeof === f || c.$$typeof === l || c.$$typeof === d || c.$$typeof === M || c.$$typeof === S || c.$$typeof === E || c.$$typeof === g);
  }, C.typeOf = N, C;
}
var T = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function xn() {
  return Fr || (Fr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, k = e ? Symbol.for("react.memo") : 60115, A = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, M = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function N(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === y || v === P || typeof v == "object" && v !== null && (v.$$typeof === A || v.$$typeof === k || v.$$typeof === f || v.$$typeof === l || v.$$typeof === d || v.$$typeof === M || v.$$typeof === S || v.$$typeof === E || v.$$typeof === g);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var he = v.$$typeof;
        switch (he) {
          case r:
            var ae = v.type;
            switch (ae) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case y:
                return ae;
              default:
                var re = ae && ae.$$typeof;
                switch (re) {
                  case l:
                  case d:
                  case A:
                  case k:
                  case f:
                    return re;
                  default:
                    return he;
                }
            }
          case n:
            return he;
        }
      }
    }
    var c = p, V = h, O = l, qe = f, Re = r, Be = d, Ge = a, we = A, B = k, Z = n, ee = i, Ce = o, Te = y, fe = !1;
    function Oe(v) {
      return fe || (fe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), le(v) || I(v) === p;
    }
    function le(v) {
      return I(v) === h;
    }
    function Pe(v) {
      return I(v) === l;
    }
    function Ne(v) {
      return I(v) === f;
    }
    function Ae(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Ke(v) {
      return I(v) === d;
    }
    function Je(v) {
      return I(v) === a;
    }
    function de(v) {
      return I(v) === A;
    }
    function pe(v) {
      return I(v) === k;
    }
    function te(v) {
      return I(v) === n;
    }
    function ve(v) {
      return I(v) === i;
    }
    function ne(v) {
      return I(v) === o;
    }
    function Ze(v) {
      return I(v) === y;
    }
    T.AsyncMode = c, T.ConcurrentMode = V, T.ContextConsumer = O, T.ContextProvider = qe, T.Element = Re, T.ForwardRef = Be, T.Fragment = Ge, T.Lazy = we, T.Memo = B, T.Portal = Z, T.Profiler = ee, T.StrictMode = Ce, T.Suspense = Te, T.isAsyncMode = Oe, T.isConcurrentMode = le, T.isContextConsumer = Pe, T.isContextProvider = Ne, T.isElement = Ae, T.isForwardRef = Ke, T.isFragment = Je, T.isLazy = de, T.isMemo = pe, T.isPortal = te, T.isProfiler = ve, T.isStrictMode = ne, T.isSuspense = Ze, T.isValidElementType = N, T.typeOf = I;
  }()), T;
}
process.env.NODE_ENV === "production" ? ir.exports = Sn() : ir.exports = xn();
var Rn = ir.exports, tt = Rn, wn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Cn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, nt = {};
nt[tt.ForwardRef] = wn;
nt[tt.Memo] = Cn;
var Tn = !0;
function On(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var at = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Tn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Pn = function(r, n, a) {
  at(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function Nn(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var An = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, jr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, $n = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", kn = /[A-Z]|^ms/g, ot = /_EMO_([^_]+?)_([^]*?)_EMO_/g, vr = function(r) {
  return r.charCodeAt(1) === 45;
}, Vr = function(r) {
  return r != null && typeof r != "boolean";
}, tr = /* @__PURE__ */ cn(function(e) {
  return vr(e) ? e : e.replace(kn, "-$&").toLowerCase();
}), Le = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(ot, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return An[r] !== 1 && !vr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var In = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Dn = ["normal", "none", "initial", "inherit", "unset"], Mn = Le, Fn = /^-ms-/, jn = /-(.)/g, Lr = {};
  Le = function(r, n) {
    if (r === "content" && (typeof n != "string" || Dn.indexOf(n) === -1 && !In.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = Mn(r, n);
    return a !== "" && !vr(r) && r.indexOf("-") !== -1 && Lr[r] === void 0 && (Lr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Fn, "ms-").replace(jn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var it = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Se(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(it);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Vn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, f = n(e);
        return G = i, Se(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = n.replace(ot, function(d, y, P) {
          var k = "animation" + l.length;
          return l.push("const " + k + " = keyframes`" + P.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + k + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function Vn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Se(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var f = n[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : Vr(f) && (a += tr(i) + ":" + Le(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(it);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Vr(f[l]) && (a += tr(i) + ":" + Le(i, f[l]) + ";");
        else {
          var p = Se(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += tr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error($n), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Yr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, st;
process.env.NODE_ENV !== "production" && (st = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, Wr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += Se(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(jr), i += f[0]);
  for (var l = 1; l < r.length; l++)
    i += Se(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(jr), i += f[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(st, function(P) {
    return p = P, "";
  })), Yr.lastIndex = 0;
  for (var h = "", d; (d = Yr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = Nn(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: G
  };
}, Ln = function(r) {
  return r();
}, Yn = X["useInsertionEffect"] ? X["useInsertionEffect"] : !1, Wn = Yn || Ln, Ue = {}.hasOwnProperty, hr = /* @__PURE__ */ X.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ _n({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (hr.displayName = "EmotionCacheContext");
hr.Provider;
var zn = function(r) {
  return /* @__PURE__ */ Kr(function(n, a) {
    var o = $t(hr);
    return r(n, o, a);
  });
}, ct = /* @__PURE__ */ X.createContext({});
process.env.NODE_ENV !== "production" && (ct.displayName = "EmotionThemeContext");
var zr = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Un = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return zr(n[1]);
}, qn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Bn = function(r) {
  return r.replace(/\$/g, "-");
}, Gn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Un(n[a]);
      if (o) {
        if (qn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Bn(o);
      }
    }
}, sr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", cr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", ut = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ue.call(n, o) && (a[o] = n[o]);
  if (a[sr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Gn(new Error().stack);
    i && (a[cr] = i);
  }
  return a;
}, Kn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return at(n, a, o), Wn(function() {
    return Pn(n, a, o);
  }), null;
}, ft = /* @__PURE__ */ zn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[sr], i = [a], f = "";
  typeof e.className == "string" ? f = On(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var l = Wr(i, void 0, X.useContext(ct));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[cr];
    p && (l = Wr([l, "label:" + p + ";"]));
  }
  f += r.key + "-" + l.name;
  var h = {};
  for (var d in e)
    Ue.call(e, d) && d !== "css" && d !== sr && (process.env.NODE_ENV === "production" || d !== cr) && (h[d] = e[d]);
  return h.ref = n, h.className = f, /* @__PURE__ */ X.createElement(X.Fragment, null, /* @__PURE__ */ X.createElement(Kn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ X.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (ft.displayName = "EmotionCssPropInternal");
var lt = ft;
function Ur(e, r, n) {
  return Ue.call(r, "css") ? je.jsx(lt, ut(e, r), n) : je.jsx(e, r, n);
}
function qr(e, r, n) {
  return Ue.call(r, "css") ? je.jsxs(lt, ut(e, r), n) : je.jsxs(e, r, n);
}
function Jn(e) {
  return Q`
    display: ${e ? "inline-flex" : "flex"};
    position: relative;
  `;
}
function Zn(e, r) {
  return Q`
    size: ${r === "small" ? "12px" : "14px"};
    margin-top: 8px;
    line-height: 22px;
    color: ${ur(e, "03")};
  `;
}
function Br(e, r, n) {
  let a;
  switch (e) {
    case "small":
      a = Q`
        font-size: 12px;
      `;
      break;
    case "large":
      a = Q`
        font-size: 24px;
      `;
      break;
    default:
      a = Q`
        font-size: 16px;
      `;
  }
  const o = r ? Qn : null;
  return Q`
    color: ${ur(n, "03")};
    ${o};
    ${a};
  `;
}
function Hn(e) {
  if (e) {
    let r;
    return e && (r = Q`
        background-color: ${ur("white", "03")};
      `), Q`
      ${r};
      flex-direction: column;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      transition: opacity 0.1s linear;
      width: 100%;
      height: 100%;
    `;
  }
}
const Xn = Dt`
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg)
  }
`, Qn = Q`
  animation: 1s linear infinite ${Xn};
`, ea = Kr((e, r) => {
  const { loading: n = !0, size: a = "medium", colorScheme: o = "blue", block: i = !0, icon: f, element: l, tip: p, children: h, ...d } = e, y = Pr(() => f ? kt(f, {
    style: Br(a, n, o).styles
  }) : l || Ur(It, { css: Br(a, n, o) }), [o, l, f, n, a]), P = Pr(() => p && Ur("span", { css: Zn(o, a), children: p }), [o, p, a]);
  return qr("div", { css: [Jn(i), Mt(e)], ref: r, ...Ft(d), children: [h, n && qr("div", { css: Hn(n), children: [y, P] })] });
});
ea.displayName = "Spin";
export {
  ea as Spin
};
//# sourceMappingURL=index.js.map
